var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("validation-observer", { ref: "form", attrs: { novalidate: "" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("section-title", {
                attrs: {
                  "container-class": "tag-badge-main-info mt-4 mb-1",
                  content: _vm.sectionTitle,
                  icon: "fas fa-clipboard-list-check"
                }
              }),
              _vm.hasOccupationalPairing
                ? _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("section-title", {
                        attrs: {
                          content: "Resumen del Pareo Ocupacional:",
                          "has-line": ""
                        }
                      }),
                      !_vm.isReadOnly
                        ? _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-text-area", {
                                        attrs: {
                                          "count-classes": [
                                            "d-block",
                                            "small-counter",
                                            "text-right"
                                          ],
                                          "custom-error-msg": "Campo requerido",
                                          disabled: _vm.isReadOnly,
                                          error: errors[0],
                                          label: "Resumen:",
                                          maxlength: 5000,
                                          "show-char-count": ""
                                        },
                                        model: {
                                          value: _vm.model.summary,
                                          callback: function($$v) {
                                            _vm.$set(_vm.model, "summary", $$v)
                                          },
                                          expression: "model.summary"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              375112919
                            )
                          })
                        : _c("div", { staticClass: "d-flex flex-column" }, [
                            _c(
                              "label",
                              {
                                staticClass: "text-muted",
                                staticStyle: { "font-size": "14px" }
                              },
                              [_vm._v(" Resumen: ")]
                            ),
                            _c("span", [_vm._v(_vm._s(_vm.model.summary))])
                          ])
                    ],
                    1
                  )
                : _vm._e(),
              _c("section-title", {
                attrs: { content: "Conclusiones Finales:", "has-line": "" }
              }),
              !_vm.isReadOnly
                ? _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-text-area", {
                                attrs: {
                                  "count-classes": [
                                    "d-block",
                                    "small-counter",
                                    "text-right"
                                  ],
                                  "custom-error-msg": "Campo requerido",
                                  disabled: _vm.isReadOnly,
                                  error: errors[0],
                                  label: "Conclusiones Finales:",
                                  maxlength: 5000,
                                  "show-char-count": ""
                                },
                                model: {
                                  value: _vm.model.finalConclusions,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "finalConclusions", $$v)
                                  },
                                  expression: "model.finalConclusions"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2086582943
                    )
                  })
                : _c("div", { staticClass: "d-flex flex-column" }, [
                    _c(
                      "label",
                      {
                        staticClass: "text-muted",
                        staticStyle: { "font-size": "14px" }
                      },
                      [_vm._v(" Conclusiones Finales: ")]
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.model.finalConclusions))])
                  ])
            ],
            1
          )
        ])
      ]),
      _c("section-title", {
        attrs: { content: "Documentos:", "has-line": "" }
      }),
      _c(
        "div",
        { staticClass: "document-row" },
        [
          !_vm.isReadOnly
            ? _c(
                "validation-observer",
                { ref: "addDocumentForm", attrs: { slim: "" } },
                [
                  _c("div", { staticClass: "row align-items-start" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "Favor de indicar el nombre del documento.",
                                        error: errors[0],
                                        label: "Nombre:",
                                        maxlength: "100"
                                      },
                                      model: {
                                        value: _vm.documentName,
                                        callback: function($$v) {
                                          _vm.documentName = $$v
                                        },
                                        expression: "documentName"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2494193019
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-file-input", {
                                      ref: "documentFileInput",
                                      attrs: {
                                        accept: _vm.acceptedDocumentTypes,
                                        "custom-error-msg":
                                          "Favor de anejar el documento.",
                                        "display-style": "normal",
                                        error: errors[0],
                                        label: "Documento:",
                                        "label-position": "left",
                                        "on-download": () => {}
                                      },
                                      model: {
                                        value: _vm.selectedDocument,
                                        callback: function($$v) {
                                          _vm.selectedDocument = $$v
                                        },
                                        expression: "selectedDocument"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1255690190
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2 btn-save-document" },
                      [
                        _c("action-button", {
                          attrs: {
                            i: "fas fa-file-plus",
                            text: "Añadir",
                            variant: "success"
                          },
                          on: { click: _vm.addDocument }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._l(_vm.visibleDocuments, function(document, index) {
        return _c(
          "div",
          { key: document.id, staticClass: "document-row row" },
          [
            _c("div", { staticClass: "col-md-4" }, [
              _c(
                "div",
                { staticClass: "color-gray-6 font-14 font-weight-normal" },
                [_vm._v(" Nombre de Documento: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [_vm._v(" " + _vm._s(document.name) + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-5" }, [
              _c(
                "div",
                { staticClass: "color-gray-6 font-14 font-weight-normal" },
                [_vm._v(" Archivo: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [_vm._v(" " + _vm._s(document.fileName) + " ")]
              )
            ]),
            _c(
              "div",
              { staticClass: "col-md-3 d-flex justify-content-end" },
              [
                _c("action-button", {
                  staticClass: "mr-2 mt-1",
                  attrs: {
                    i: "fas fa-file-download text-white mr-n1 pr-1",
                    variant: "success"
                  },
                  on: {
                    click: function($event) {
                      return _vm.downloadDocument(document)
                    }
                  }
                }),
                !_vm.isReadOnly
                  ? _c("action-button", {
                      staticClass: "mt-1",
                      attrs: {
                        i: "fas fa-times text-danger mr-n1 pr-1",
                        variant: "outline-danger"
                      },
                      on: {
                        click: function($event) {
                          return _vm.removeDocument(index)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        )
      }),
      _vm.canShowMoreDocuments
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 d-flex justify-content-center my-3" },
              [
                _c(
                  "action-button",
                  {
                    attrs: {
                      variant:
                        "outline-success custom-view-more actionButton rounded-pill"
                    },
                    on: { click: _vm.loadMoreDocuments }
                  },
                  [
                    _vm._v(" Ver más "),
                    _c("i", { staticClass: "ml-1 fas fa-chevron-down" })
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }